import React from 'react';

import Switch from '../Wizard/Switch';
import { ConsumerActionStatus, ListClaim } from '../../api/types';
import { ClaimStatus, ClaimType } from '../parcel-finder/claims/types';

type ClaimsCenterSwitchProps = {
  children: React.ReactNode;
  isLoading: boolean;
  error: unknown;
  data: ListClaim[];
  statuses: ClaimStatus[];
  shipmentTypes: ('7s' | 'non-7s')[];
  types: ClaimType[];
  consumerActionStatuses: ConsumerActionStatus[];
};

function ClaimsCenterSwitch(props: ClaimsCenterSwitchProps) {
  return <Switch selected={getLoadingState(props)}>{props.children}</Switch>;
}

export function getLoadingState(state: ClaimsCenterSwitchProps): string {
  const { isLoading, error, data, statuses, shipmentTypes, types, consumerActionStatuses } = state;

  if (isLoading) {
    return 'loader';
  }

  if (data.length !== 0) {
    return 'results';
  }

  if (error) {
    return 'error';
  }

  const isFilterApplied =
    statuses.length > 0 || types.length > 0 || shipmentTypes.length > 0 || consumerActionStatuses.length > 0;
  if (isFilterApplied && data.length === 0 && !isLoading) {
    return 'no-filter-results';
  }

  return 'no-results';
}

export default React.memo(ClaimsCenterSwitch);
